module.exports = __webpack_public_path__ + "img/hok4.3c1ebab9.png";